import React, { useMemo, useState } from "react";
import { makeStyles } from "tss-react/mui";

import {
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Link as MUILink,
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { PageFrame } from "components/auth/PageFrame";
import {
  APP_HOME,
  CREATE_ACCOUNT,
  PASSWORD_RECOVERY,
} from "routers/routePaths";
import { fetchAuthentication } from "api/auth";
import { useSetLoginToken } from "contexts/UserContext";
import { useSetError } from "contexts/ErrorContext";
import { Link } from "react-router-dom";

const style = makeStyles()((theme) => ({
  inputField: {
    marginBottom: theme.spacing(4),
  },
  forgotPassword: {
    textAlign: "left",
    marginBottom: theme.spacing(2),
  },
  submitBtn: {
    marginTop: theme.spacing(2),
  },
}));

export const Login = ({ history, location }) => {
  const { classes } = style();
  const setLoginToken = useSetLoginToken();
  const [hidePassword, setHidePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const setGlobalError = useSetError();

  const toggleVisibility = () => {
    setHidePassword((prev) => !prev);
  };

  const passwordIcon = useMemo(
    () => (
      <InputAdornment position="end">
        <IconButton onClick={toggleVisibility}>
          {hidePassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
        </IconButton>
      </InputAdornment>
    ),
    [hidePassword]
  );

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const token = await fetchAuthentication({ email, password });
      setLoginToken(token);
      history.push(location?.state?.from ? location.state.from : APP_HOME);
    } catch (error) {
      // @ts-expect-error
      setGlobalError(error.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageFrame
      title="Todas as soluções de energia em uma única plataforma."
      centerText
      anchorData={{
        text: "Clique aqui para criar.",
        to: CREATE_ACCOUNT,
        prefix: "Não tem conta?",
      }}
    >
      <TextField
        id="email"
        label="Seu e-mail"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
        disabled={loading}
        className={classes.inputField}
      />

      <TextField
        id="adornment-password"
        label="Sua senha"
        variant="outlined"
        color="primary"
        fullWidth
        disabled={loading}
        type={hidePassword ? "text" : "password"}
        InputProps={{ endAdornment: passwordIcon }}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className={classes.inputField}
      />
      <div className={classes.forgotPassword}>
        <Typography variant="body1">
          <MUILink component={Link} to={PASSWORD_RECOVERY} underline="always">
            Esqueci minha senha
          </MUILink>
        </Typography>
      </div>

      <Button
        fullWidth
        disabled={loading}
        variant="contained"
        color="primary"
        size="large"
        className={classes.submitBtn}
        onClick={handleSubmit}
      >
        {loading ? <CircularProgress size={24} /> : "Fazer Login"}
      </Button>
    </PageFrame>
  );
};
